// extracted by mini-css-extract-plugin
export default {"uploadedContainer":"style_uploadedContainer__o3s4M","imgName":"style_imgName__r43mj","imgSize":"style_imgSize__GpMK3","deleteContainer":"style_deleteContainer__2cq26"};